import React, { useState, useEffect, createContext, useContext, useCallback } from 'react';
import { getUser, signIn as sendSignInRequest } from '../api/auth';
import { getSelectedLanguageFromLocalStorage, setUserToLocalStorage } from '../utils/localStorage-utils';

function AuthProvider(props) {
  const [user, setUser] = useState();
  const [loading, setLoading] = useState(true);
  const [activeLanguage, setActiveLanguage] = useState(getSelectedLanguageFromLocalStorage)

  useEffect(() => {
    (async function () {
      try {

        const result = await getUser();

        if (result.isOk) {
          setUser(result.data);
          setUserToLocalStorage(result.data)
        }
        else
          setUser(undefined)

        setLoading(false);
      } catch (error) {
        console.log(error)
      }

    })();

  }, []);

  const signIn = useCallback(async (email, password) => {
    const result = await sendSignInRequest(email, password);
    if (result.isOk) {
      //console.log(result.data)
      setUser(result.data);
      setUserToLocalStorage(result.data)
    }

    return result;
  }, []);

  const signOut = useCallback(() => {
    setUser(undefined);
    localStorage.removeItem("user")
  }, []);

  const getListPermissionProps = useCallback((section) => {
    var result = {}
    if (user) {
      result.allowAdding = user.claims.filter(item => item.name === "TalentWavePermission" && item.value === `${section}_Create`).length > 0
      result.allowDeleting = user.claims.filter(item => item.name === "TalentWavePermission" && item.value === `${section}_Delete`).length > 0
      result.allowUpdating = user.claims.filter(item => item.name === "TalentWavePermission" && item.value === `${section}_Update`).length > 0
    }

    return result
  }, [user]);

  return (
    <AuthContext.Provider value={{
      user, setUser,
      signIn, signOut,
      loading, setLoading,
      activeLanguage, setActiveLanguage,
      getListPermissionProps
    }} {...props} />
  );
}

const AuthContext = createContext({ loading: false });
const useAuth = () => useContext(AuthContext);

export { AuthProvider, useAuth }
